import type { CostModel } from '../core/types/margin'

/**
 * Startschatting (oktober 2026, zonder btw). Sarah vervangt ze in Instellingen › Kosten en marge
 * door haar eigen tarieven; later vervangen de echte Mollie- en PostNL-cijfers de schatting.
 */
export const defaultCostModel: CostModel = {
  payment: {
    ideal: { fixedCents: 32, percent: 0 },
    bancontact: { fixedCents: 39, percent: 0 },
    card: { fixedCents: 25, percent: 1.8 },
    klarna: { fixedCents: 35, percent: 2.99 },
    incasso: { fixedCents: 30, percent: 0 },
    pin: { fixedCents: 5, percent: 0.9 },
  },
  shipping: { 'brievenbus-nl': 440, 'pakket-nl': 695, 'pakket-be': 950 },
  packaging: { pakket: 145, brievenbus: 55 },
  returnsPercent: 2,
  targetBoxLeftCents: 1500,
  subscriptionGiftCents: 0,
  checkedOn: '2026-10-13',
}
